import {
  rtlLanguages,
  supportedApplicationLanguages,
  defaultApplicationLanguage,
} from 'locales/_languages';
import getLanguageFromUrl from 'shared/utils/getLanguageFromUrl';

/**
 * @return {'en'|'he'|'ar'}
 */
export const getCurrentLanguage = () => {
  const urlLanguage = getLanguageFromUrl();

  return supportedApplicationLanguages.includes(urlLanguage)
    ? urlLanguage
    : defaultApplicationLanguage;
};

/**
 * returns {boolean}
 */
export const isCurrentLanguageRtl = () => {
  const urlLanguage = getLanguageFromUrl() || defaultApplicationLanguage;

  return rtlLanguages.includes(urlLanguage);
};

/**
 * @example '/login' -> '/he/login'
 * @example '/appointments' -> '/en/appointments'
 */

export const getLanguage = getCurrentLanguage;
export const isRtl = isCurrentLanguageRtl;
